<template>
  <div class="footer">
    <img class="upImg" @click="scrollToTop" src="../assets/images/top.png" alt="" />
    <div class="top-footer">
      <img src="../assets/images/word.png" class="imgBox" alt="" />
      <ul class="listBox">
        <li v-for="(item, i) in navList" :key="item.id" @click="handleGo(item)">
          {{ item.name }}
        </li>
      </ul>
      <p class="brand">BAIBAITU</p>
    </div>
    <div class="bottom-footer">
      <p class="address">公司地址：湖南省长沙未来漫城SOHO国际22楼</p>
      <div class="codeBox">
        <img src="../assets/images/weixin.jpg" alt="" />
        <img src="../assets/images/weChat-1.png" alt="" />
        <img src="../assets/images/xiaohongshu.png" alt="" />
      </div>
      <p class="record">版权所有 湘ICP备2024088577号-2</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',

  data() {
    return {
      navList: [
        {
          name: '产品',
          path: '/product'
        },
        {
          name: '品牌故事',
          path: '/home'
        },

        {
          name: '品牌加盟',
          path: '/Business'
        },
        {
          name: '最新资讯',
          path: '/article'
        },
        {
          name: '联系我们',
          path: '/about'
        }
      ]
    }
  },

  methods: {
    handleGo(item) {
      this.$router.push({
        path: item.path
      })
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  font-family: PingFangSC, PingFang SC;
  background-image: url(../assets/images/footer.png);
  background-size: cover;
  position: relative;
  width: 100vw;
  margin: 0 auto;
  font-size: 23px;
  color: #ffffff;
  .top-footer {
    display: flex;
    justify-content: space-between;
    margin: 0 110px 0 250px;
    padding-top: 150px;
    .imgBox {
      width: 405px;
      object-fit: cover;
    }
    .listBox {
      width: 158px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      li {
        font-family: PingFangSC, PingFang SC;
        font-size: 16px;
        color: #ffffff;
        line-height: 22px;
        text-align: left;
      }
    }
    .brand {
      font-family: HYk2gj;
      font-size: 48px;
      color: #ffffff;
      line-height: 180px;
      letter-spacing: 4px;
    }
  }
  .bottom-footer {
    display: flex;
    margin: 12px 110px 0 250px;
    padding-bottom: 80px;
    align-items: center;
    .address {
      font-size: 24px;
      color: #ffffff;
      line-height: 33px;
      width: 683px;
      margin-right: 100px;
    }
    img {
      width: 78px;
      object-fit: cover;
      margin-right: 18px;
    }
    .record {
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
      width: 298px;
      text-align: right;
      margin-left: 190px;
    }
  }
  .upImg {
    width: 124px;
    position: absolute;
    top: -13%;
    left: 50%;
    transform: translateX(-50%);
  }
  .codeBox {
    display: flex;
  }
}
@media (max-width: 768px) {
  .footer {
    font-size: 14px;
  }
}
</style>
